import { useEffect, useRef } from "react";

export function createSpriteCanvas(name: string, isSelect: boolean = false) {

    if (name == null) return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const canvasWidth = 100 + (name?.length || 0) * 100
    const canvasHeight = 330

    ctx.canvas.width = canvasWidth;
    ctx.canvas.height = canvasHeight;

    ctx.fillStyle = '#00000000'; // 设置背景颜色为透明
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);
    // 圆角矩形参数
    const rectX = 0;         // 矩形左上角X坐标
    const rectY = 0;         // 矩形左上角Y坐标
    const rectWidth = canvasWidth;    // 矩形宽度
    const rectHeight = 250;   // 矩形高度
    const cornerRadius = 40;  // 圆角半径

    // 绘制圆角矩形路径
    ctx.beginPath();
    ctx.moveTo(rectX + cornerRadius, rectY);
    ctx.lineTo(rectX + rectWidth - cornerRadius, rectY);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + cornerRadius);
    ctx.lineTo(rectX + rectWidth, rectY + rectHeight - cornerRadius);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - cornerRadius, rectY + rectHeight);
    ctx.lineTo(rectX + cornerRadius, rectY + rectHeight);
    ctx.quadraticCurveTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - cornerRadius);
    ctx.lineTo(rectX, rectY + cornerRadius);
    ctx.quadraticCurveTo(rectX, rectY, rectX + cornerRadius, rectY);
    ctx.closePath();

    // 填充白色
    ctx.fillStyle = isSelect ? '#0020ff' : '#ffffff';
    ctx.fill();

    // 绘制下方三角形
    ctx.beginPath()
    ctx.moveTo(rectWidth / 2 - 80, rectHeight)
    ctx.lineTo(rectWidth / 2, rectHeight + 80)
    ctx.lineTo(rectWidth / 2 + 80, rectHeight)
    ctx.lineTo(rectWidth / 2 - 80, rectHeight)

    ctx.closePath()
    ctx.fillStyle = isSelect ? '#0020ff' : '#ffffff'
    ctx.fill()

    // 绘制文字
    ctx.font = 'normal 130px Arial'
    ctx.fillStyle = isSelect ? "#ffffff" : "#212121"
    ctx.textAlign = "center"
    ctx.fillText(name, canvasWidth / 2, canvasHeight / 2, canvasWidth)

    return canvas
}

export function createMonitorSpriteCanvas(name: string) {

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const canvasWidth = 200 + name.length * 200
    const canvasHeight = 1250

    const tagHeight = 410

    canvas.width = canvasWidth
    canvas.height = canvasHeight * 2

    ctx.fillStyle = '#00000000'; // 设置背景颜色为透明
    ctx.fillRect(0, 0, canvasWidth, canvasHeight * 2);

    // 圆角矩形参数
    const rectX = 0;         // 矩形左上角X坐标
    const rectY = 0;         // 矩形左上角Y坐标
    const rectWidth = canvasWidth;    // 矩形宽度
    const rectHeight = tagHeight;   // 矩形高度
    const cornerRadius = 80;  // 圆角半径

    // 绘制圆角矩形路径
    ctx.beginPath();
    ctx.moveTo(rectX + cornerRadius, rectY);
    ctx.lineTo(rectX + rectWidth - cornerRadius, rectY);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + cornerRadius);
    ctx.lineTo(rectX + rectWidth, rectY + rectHeight - cornerRadius);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - cornerRadius, rectY + rectHeight);
    ctx.lineTo(rectX + cornerRadius, rectY + rectHeight);
    ctx.quadraticCurveTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - cornerRadius);
    ctx.lineTo(rectX, rectY + cornerRadius);
    ctx.quadraticCurveTo(rectX, rectY, rectX + cornerRadius, rectY);
    ctx.closePath();

    // 填充白色
    ctx.fillStyle = '#00AAB5';
    ctx.filter = 'drop-shadow(0px 0px 12px 0px #00F0FF)';
    ctx.fill();

    // 绘制边框
    ctx.strokeStyle = '#00F0FF';
    ctx.lineWidth = 10;
    ctx.beginPath();
    ctx.moveTo(rectX + cornerRadius, rectY);
    ctx.lineTo(rectX + rectWidth - cornerRadius, rectY);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + cornerRadius);
    ctx.lineTo(rectX + rectWidth, rectY + rectHeight - cornerRadius);
    ctx.quadraticCurveTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - cornerRadius, rectY + rectHeight);
    ctx.lineTo(rectX + cornerRadius, rectY + rectHeight);
    ctx.quadraticCurveTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - cornerRadius);
    ctx.lineTo(rectX, rectY + cornerRadius);
    ctx.quadraticCurveTo(rectX, rectY, rectX + cornerRadius, rectY);
    ctx.stroke()

    // 绘制文字
    ctx.font = 'normal 200px Verdana'
    ctx.fillStyle = '#fff'
    ctx.textAlign = "center"
    ctx.textBaseline = 'middle';
    ctx.fillText(name, canvasWidth / 2, tagHeight / 2)

    // 绘制直线
    ctx.strokeStyle = '#00F0FF';
    ctx.lineWidth = 10;
    ctx.beginPath()
    ctx.moveTo(canvasWidth / 2, canvasHeight)
    ctx.lineTo(canvasWidth / 2, canvasHeight - 760)
    ctx.stroke()

    ctx.beginPath()
    ctx.arc(canvasWidth / 2, canvasHeight - 760, 25, 0, 2 * Math.PI, false)
    ctx.fillStyle = "#00F0FF"
    ctx.fill()



    return canvas
}